import { IDeviceActionRequest } from '@components/DeviceActionModal/types';

enum ActionTypes {
  ACTIVATION_MULTI_CONNECT = 0,
  ACTIVATION_MOT = 1,
  NETWORK_RESET = 3,
  SIMCARD_RESET = 4,
  OPERATOR_RESTRICTION = 5,
  PRIORITY_OPERATOR = 6,
  BLOCK_USE = 7,
  PLASTIC_CHANGE = 8,
  CONTRACT_SUSPEND = 9,
  PROVISIONAL_WITHDRAW = 10,
  CLIENT_ACTIVATION = 11,
  SMS_BLOCK = 12,
  SMS_UNBLOCK = 13,
  NICKNAME_CHANGE = 16,
  UNLOCK_USE = 17,
  APN_ADD = 18,
  APN_REMOVE = 19,
  NETWORK_BLOCK = 20,
  NETWORK_UNLOCK = 21,
  IMEI_LOCK = 22,
  IMEI_UNLOCK = 23,
  SUSPENSION = 24,
  WITHDRAWAL_OF_SUSPENSION = 25,
  PLASTIC_EXCHANGE = 26,
  MOT_DEACTIVATION = 27,
  MSISDN_EXCHANGE = 28,
  MANUAL_ACTIVATION = 29,
  FORCE_REACTIVATION = 30,
  FINANCIAL_LOCK = 31,
  FINANCIAL_UNLOCK = 32,
  ADD_CREDIT_TO_SIMCARD = 33,
  CHANGE_SIMCARD = 34,
  ALGAR_BAIT_RENEWAL = 37,
  CONTRACT_MOVEMENT = 39,
  CANCELLATION_SUSPENSION = 40,
  BROKER_CANCELLATION = 41,
  BROKER_CANCELLATION_WAIVER = 42,
  BROKER_SUBSTITUTION = 43,
  MOT_OPERATOR_CHANGE = 44,
  HLR_REPROG = 45,
  ALLOWANCE_PLAN_RENEWAL = 48,
  BAIT_RENEWAL = 49,
  CREDIT_PURCHASE = 50,
  SYNC_APN = 51,
  CANCELLATION = 52,
  ADDING_PERMISSIONS = 53,
  REMOVAL_PERMISSIONS = 54,
  SEND_SMS = 124,
  // -----
  TRANSFER = 1234,
  CHANGE_APN = 100,
}

export default ActionTypes;

export enum LorawanActionTypes {
  TRANSFER = -1,
  ACTIVATION = 0,
  DEACTIVATION = 1,
  IMPORT = 2,
  UPLINK_BLOCKING = 10,
  UPLINK_UNBLOCKING = 11,
  DOWNLINK_BLOCKING = 12,
  DOWNLINK_UNBLOCKING = 13,
  CHANGE_DESCRIPTION = 14,
  CHANGE_TAGS = 15,
  FORWARDING = 16,
  FORWARDING_DELETION = 17,
  NEW_CONNECTION = 16,
  CONNECTION_REMOVAL = 17,
  DOWNLINK_SCHEDULE = 18,
  SUSPENSION = 20,
  REACTIVATION = 21,
  CONNECTING_LINK = 22,
  TOKEN_ACTIVATION = 50,
}

export const motLorawanActionTypes = [
  LorawanActionTypes.TRANSFER,
  LorawanActionTypes.ACTIVATION,
  LorawanActionTypes.IMPORT,
  LorawanActionTypes.DEACTIVATION,
  LorawanActionTypes.UPLINK_BLOCKING,
  LorawanActionTypes.UPLINK_UNBLOCKING,
  LorawanActionTypes.DOWNLINK_BLOCKING,
  LorawanActionTypes.DOWNLINK_UNBLOCKING,
  LorawanActionTypes.CHANGE_DESCRIPTION,
  LorawanActionTypes.CHANGE_TAGS,
  LorawanActionTypes.TOKEN_ACTIVATION,
  LorawanActionTypes.SUSPENSION,
  LorawanActionTypes.REACTIVATION,
  LorawanActionTypes.CONNECTING_LINK,
];

export const sendDeviceAction = ({
  api,
  payload,
  username,
}: IDeviceActionRequest) =>
  api
    .post('/service-proxy/actions', payload, {
      params: {
        username,
      },
    })
    .catch((err: any) => {
      throw new Error(err);
    });
